import {GameFlowController} from '../../components/game-flow-controller.js';
import {MenuPanels} from '../../models/UIModel.js';
import {SkipMissionButton} from '../panels/skip-mission.js';

export function goToSkipMissions(missionID: number) {
    if (!GameFlowController.instance.popupShowing) {
        GameFlowController.instance.pushPopupMenu(MenuPanels.SkipMission);
        SkipMissionButton.instance.setMission(missionID);
        //SkipMissionButton.instance.setMissionReqScreen(missionReqScreen);
    }
}
